import React from 'react';

import styles from 'src/components/Confirmed.scss';
import {withTranslation} from 'react-i18next'

const Confirmed = ({t}) => <div className={styles.container}>{t("components.Confirmed")}</div>;
export default withTranslation()(Confirmed);
